import { response } from 'express';
import React, { useState, useEffect, useReducer } from 'react';
import SkillPathGroupComponent from '../components/SkillPathGroupComponent'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { loginRequest, protectedResources } from "../authConfig";
import { isMobile } from 'react-device-detect';
import useWindowDimensions from '../hooks/windowDimensions';
import { Icon } from '../components/icons/icons';
import Loading from '../components/Loading/Loading';
import "../styles/pages/SkillPath.scss";
import ChatBullets from '../components/skillpath/ChatBullets';
import parse from 'html-react-parser';
import { ISkill } from '../model/Skill.model';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/Accordion/Accordion';
import { ISkillGroup } from '../model/SkillGroup.model';
import { ISkillPath } from '../model/SkillPath.model';
import LevelIcon from '../components/skillpath/LevelIcon';
import SkillDivider from '../components/skillpath/SkillDivider';
import DesktopSkillGrid from '../components/skillpath/DeskTopSkillGrid';
import { ISkillLevel } from '../model/SkillLevel.model';
import { ISkillDetail } from '../model/SkillDetail.model';
import { IEmployeeProgression } from '../model/EmployeeProgression.model';
import EmployeeProgressionOptions from '../components/skillpath/EmployeeProgressionOptions';
import MobileSkillView from '../components/skillpath/MobileSkillView';
import { IEmployeeProgressionLevel } from '../model/EmployeeProgressionLevel.model';

const SkillPathPage = (props: any) => {
  const h = 'height: 73.172;';
  const { error, execute } = useFetchWithMsal({
    scopes: protectedResources.apiCFSkillPath.scopes.read,
  });
  var { parentid, id } = useParams();
  var allPaths = [];


  const [searchParams] = useSearchParams();
  const showAll = searchParams.get('showAll')?.toLowerCase() === 'true';
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  const [parentSkillPath, setParentSkillPath] = useState(null);
  const [skillPath, setData] = useState(null);
  const [loadingSkillPath, setLoadingSkillPath] = useState(true);
  const [skillGroups, setSkillGroups] = useState(Array<ISkillGroup>);
  const [filteredSkillGroups, setFilteredSkillGroups] = useState(Array<ISkillGroup>);
  const [filterArray, setFilterArray] = useState({});
  const [employeeProgressions, setEmployeeProgressions] = useState<IEmployeeProgression[]>([]);
  const [employeeProgressionLevels, setEmployeeProgressionLevels] = useState<IEmployeeProgressionLevel[]>([]);
  const [empsLoaded, setEmpsLoaded] = useState<boolean>(false);
  const [isMobileClient, setIsMobileClient] = React.useState<boolean>(false);
  const [isMobileFilterShowing, setIsMobileFilterShowing] = React.useState<boolean>(false);
  const [resetMobileFilterCheckboxes, setResetMobileFilterCheckboxes] = React.useState<boolean>(false);
  const { height, width } = useWindowDimensions();

  /* #region Classes */
  const skillsContainerClasses = ['skills-container', 'padded'];
  if (!isMobileClient) skillsContainerClasses.push('desktop');

  const mobileFilterClasses = ['mobile-filter-skills-container'];
  if (isMobileFilterShowing) mobileFilterClasses.push("visible");

  /* #endregion Classes */

  /* #region Use Effects */
  useEffect(() => {
    const finalValue = isMobile || width < 1100;
    setIsMobileClient(finalValue);
  }, [width]);

  useEffect(() => {
    if (!id) return;
    if (!skillPath || (skillPath as ISkillPath).skillPathId + ""!==id) {
      if (skillPath!==null && parentSkillPath!==null && (skillPath as any).parentSkillPathId + "" !== (parentSkillPath as ISkillPath).skillPathId) {
        setParentSkillPath(null);
        //setFilterArray({});
        setFilteredSkillGroups([]);
      }
      if (skillPath!==null && (skillPath as any).skillPathId + "" !== id) {
        setParentSkillPath(null);
        //setFilterArray({});
        setFilteredSkillGroups([]);
      }
      execute("GET", `/api/SkillPath/${id}`)
        .then(response => {
          if (!response) return;
          console.log('sp return', response);
          setData(response);
          allPaths.push(response);
          setLoadingSkillPath(false);
          if (!showAll) {
            setFilterArray({});
          } else {
            window.setTimeout(() => {
              setFilterArray(response.skillGroups.reduce((acc: any, group: ISkillGroup) => {
                acc[group.skillGroupId] = (group.skills) ? group.skills.map((skill: ISkill) => skill.SkillId) : [];
                return acc;
              }, {}));
              console.log('filterarray--', filterArray);
              RefreshFilterData();
              forceUpdate();
            }, 1500);
          }
        })
    }
  }, [execute, skillPath, id]);
  useEffect(() => {
    if (!skillPath || !skillGroups.length) return;//wait until other stuff is loaded
    if (empsLoaded) return;
    execute("GET", `/api/EmpProgs`)
    .then(response => {
      if (!response) return;
      console.log('parent sp return', response);
      var progressions = response.progressions;
      var levels = response.levels;
      setEmployeeProgressions(progressions);
      setEmployeeProgressionLevels(levels);
      setEmpsLoaded(true);
    })
  }, [employeeProgressions, empsLoaded, skillPath, skillGroups]);

  useEffect(() => {
    if (!parentid) return;
    if (!parentSkillPath) {
      execute("GET", `/api/SkillPath/${parentid}`)
      .then(response => {
        setParentSkillPath(response);
        console.log('parent skill path', response)
        
      })
    }
  }, [execute, parentSkillPath, parentid]);

  useEffect(() => {
    if (skillPath && (skillGroups.length < 1 || skillGroups[0].skillPathId + ""!==id)) {
      execute("GET", `/api/SkillGroup/GroupsByPathId/${id}`)
        .then(response => {
          setSkillGroups(JSON.parse(JSON.stringify(response)));
          //setFilteredSkillGroups(JSON.parse(JSON.stringify(response)));
          setLoadingSkillPath(false);
        })
    }
  }, [id, skillPath, loadingSkillPath])



  /* #endregion Use Effects */

  /* #region Functions */
  const closeMobileFilterClick = () => {
    setIsMobileFilterShowing(false);
  }

  const showMobileFilterClick = () => {
    setIsMobileFilterShowing(true);
  }

  const resetMobileFilterCheckboxesClick = () => {
    setResetMobileFilterCheckboxes(true);
  }

  const returnDraftJSContentAsHTML = (draftJsContent: any) => {
    let aryHTML: Array<any> = [];
    const parser = new DOMParser();
    const returnHTML = parser.parseFromString(draftJsContent, "text/html").body.children;
    for (let i = 0; i < returnHTML.length; i++) {
      const element = parse(returnHTML[i].outerHTML);
      aryHTML.push(element);
    }
    console.log("ary HTML", aryHTML);
    return aryHTML;
  }

  const getSkillDetails = (skill: any, skillLevels:ISkillLevel[]) => {
    let returnArray: Array<any> = [];
    if (Array.isArray(skill.details) && Array.isArray(skillLevels)) {
    return <>
    {skillLevels.map(level => (<>
    <div><h3>{level.skillLevelName}</h3>
    {skill.details.filter((det:ISkillDetail) => det.skillLevelId===level.skillLevelId).map((detail: any) => (<><p className='m-t--75 m-b--75'>{parse(detail.skillText)}</p></>))}
    </div>
    </>))}
    </>;
    }
    //debugger;
    return <></>;
  }
  const createUniqueKey = (skillGroupId: string, SkillId: string, index: number) => {
    return skillGroupId + "-" + SkillId + "-" + index;
  }

  const getLevelIcon = (index: number) => {
    switch (index) {
      case 0:
        return 'icon-novice';
      case 1:
        return 'icon-mid-level';
      case 2:
        return 'icon-advanced';
      default:
        console.log("missed case in SkillPath.tsx > getLevelIcon,  index = " + index);
        return 'icon-novice';
    }
  }

  const getDividerText = (skillPathName: string, skillGroupName: string, skillName: string) => {
    return skillPathName + " : " + skillGroupName + " : " + skillName;
  }
  const SortSkills = (skills:ISkill[]) => {
    skills.forEach((sk:ISkill) => {
      (sk as any).progression = employeeProgressions.find(p => p.skillId===sk.SkillId);
    });
    skills.sort((sk1:any, sk2:any)=> {
      if (!(sk1 as any).progression && !(sk2 as any).progression) {
        if (sk1.indexNumber > sk2.indexNumber) return 1;
        if (sk1.indexNumber < sk2.indexNumber) return -1;
        return 0;
      }
      if ((sk1 as any).progression && !(sk2 as any).progression) {
        return 1;
      }
      if (!(sk1 as any).progression && (sk2 as any).progression) {
        return -1;
      }
      if ((sk1 as any).progression.stage !== (sk2 as any).progression.stage) {
        if ((sk1 as any).progression.stage < (sk2 as any).progression.stage) return -1;
        if ((sk1 as any).progression.stage > (sk2 as any).progression.stage) return 1;
      }
      if (sk1.indexNumber > sk2.indexNumber) return 1;
      if (sk1.indexNumber < sk2.indexNumber) return -1;
      return 0;
    });
    return JSON.parse(JSON.stringify(skills));
  }
  const SortSkillGroups = (skillGroups:ISkillGroup[]) => {
    skillGroups.forEach(grp => {
      if (!grp.skills) return;
      grp.skills = SortSkills(grp.skills);
    });
    return JSON.parse(JSON.stringify(skillGroups));
  }
  const HandleSkillFilterUpdate = (skillGroup:ISkillGroup, ids:string[]) => {
    if (ids && ids.length) {
      (filterArray as any)[skillGroup.skillGroupId] = ids;
    } else if ((filterArray as any)[skillGroup.skillGroupId] !==undefined) {
      (filterArray as any)[skillGroup.skillGroupId] = undefined;
    }
    setFilterArray(filterArray);
    console.log('filterarray', filterArray)
    RefreshFilterData();
  }
  const RefreshFilterData = () => {
    let idarr:string[] = [];
    for (let [key, value] of Object.entries(filterArray)) {
      idarr.push(key);
    }
    var filteredSkillGroups = JSON.parse(JSON.stringify(skillGroups)).filter((g:any) => idarr.indexOf(g.skillGroupId)>-1);
    filteredSkillGroups.forEach((grp:ISkillGroup) => {
      if (!grp.skills || grp.skills.length<1) {return;}
      var gfiltafish = (filterArray as any)[grp.skillGroupId];
      if (!gfiltafish) {grp.skills = []; return;}
      let skills = grp.skills.filter(s => gfiltafish.indexOf(s.SkillId)>-1);
      grp.skills = SortSkills(skills);
    });
    setFilteredSkillGroups(JSON.parse(JSON.stringify(filteredSkillGroups)));
    //forceUpdate();
    console.log('filter', filterArray);
  }

  const navigate = useNavigate();
  const HandleSubSkillPathSelection = (event:any) => {
    if (!event.currentTarget.value) return;
    if (parentid){
      navigate(`/skillpath/${parentid}/${event.currentTarget.value}`);
    } else {
      navigate(`/skillpath/${id}/${event.currentTarget.value}`);
    }
    //Navigate({to: `skillpath/${parentid}/${event.currentTarget.value}`});
  }
  const HandleBookmarkRemoved = (bookmark:IEmployeeProgression) => {
    var bm = employeeProgressions.find(prog => prog.employeeProgressionId===bookmark.employeeProgressionId);
    if (!bm) return;
    employeeProgressions.splice(employeeProgressions.indexOf(bm), 1);
    setEmployeeProgressions(JSON.parse(JSON.stringify(employeeProgressions)));
    //console.log('current progs', employeeProgressions);
    //RefreshFilterData();
  }
  function HandleBookmarkAdded(bookmark: IEmployeeProgression): void {
    employeeProgressions.push(bookmark);
    setEmployeeProgressions(JSON.parse(JSON.stringify(employeeProgressions)));
  }
  const HandleProgressionLevelAdded = (progressionLevel:any) => {
    console.log('handle progression level added', progressionLevel);
    employeeProgressionLevels.push(progressionLevel);
    setEmployeeProgressionLevels(JSON.parse(JSON.stringify(employeeProgressionLevels)));
  };
  const HandleProgressionLevelRemoved = (progressionLevelId:any) => {
    console.log('handle progression level removed', progressionLevelId);
    const index = employeeProgressionLevels.findIndex(ep => ep.employeeProgressionLevelId === progressionLevelId);
    if (index > -1) {
      employeeProgressionLevels.splice(index, 1);
      setEmployeeProgressionLevels(JSON.parse(JSON.stringify(employeeProgressionLevels)));
    }
  };
  const HandleProgressionLevelUpdated = (progressionLevel:any) => {
    console.log('handle progression level updated', progressionLevel);
    const index = employeeProgressionLevels.findIndex(ep => ep.employeeProgressionLevelId === progressionLevel.employeeProgressionId);
    if (index > -1) {
      employeeProgressionLevels[index] = progressionLevel;
      setEmployeeProgressionLevels(JSON.parse(JSON.stringify(employeeProgressionLevels)));
    }
  };
  const GetSkillProgressionById = (skillId:string) => {
    var ep = employeeProgressions.find((ep:any) => ep.skillId===skillId);
    if (ep?.skillId!==skillId) return undefined;
    return ep;
  }

  /* #endregion Functions */

  if (error) {
    debugger;
    //@ts-ignore
    return <div>Error: {error.message}</div>;
  }

  if (!skillPath) return (
    <Loading isLoading={true} />
  );

  if (parentid && (!parentSkillPath || !(parentSkillPath as ISkillPath).skillPathName)) {
    return <Loading isLoading={true} />
  }

  if (isMobileClient) {
    return (
      <>
        <div className={skillsContainerClasses.join(' ')} style={{borderColor : (skillPath as any).highlightColor}} >
            {
              parentSkillPath && (parentSkillPath as any) && 
              (<>{(parentSkillPath as ISkillPath).skillPathName}</>)
            }
          <h2 className='fnt-wght-bold m-b-1'>{(skillPath as any).skillPathName}</h2>
          <div className='skills-description-container'>
            {
              parentSkillPath && (parentSkillPath as any).subSkillPaths && (parentSkillPath as any).subSkillPaths.length>0 && 
              (<>Skill focus areas for your Discipline<br/><select onChange={HandleSubSkillPathSelection} value={id}>
                <option value="">Select one</option>
                {(parentSkillPath as any).subSkillPaths.sort((a:ISkillPath, b:ISkillPath) => {if (a.skillPathName>b.skillPathName) return 1; return -1;}).map((subPath:ISkillPath) => (
                  <option value={subPath.skillPathId}>{subPath.skillPathName}</option>
                  ))}
                </select></>)
            }
            {
              skillPath && (skillPath as any) && (skillPath as any).skillPathDescription && (skillPath as any).skillPathDescription && (
                returnDraftJSContentAsHTML((skillPath as any).skillPathDescription)
              )
            }
                        {
              skillPath && (skillPath as any).subSkillPaths && (skillPath as any).subSkillPaths.length>0 && 
              (<>Skill focus areas for your Discipline<br/><select onChange={HandleSubSkillPathSelection}>
                <option value="">Select one</option>
                {(skillPath as any).subSkillPaths.sort((a:ISkillPath, b:ISkillPath) => {if (a.skillPathName>b.skillPathName) return 1; return -1;}).map((subPath:ISkillPath) => (<option value={subPath.skillPathId}>{subPath.skillPathName}</option>))}
                </select></>)
            }
          </div>
          <button className='btn-white bdr-radius-0 m-t-1' title="Show Filter Menu" onClick={showMobileFilterClick}>Select Skills</button>
          <section className={mobileFilterClasses.join(' ')}>
            <button className='mobile-filter-skills-close-button' onClick={closeMobileFilterClick}>&times;</button>
            <div className='mobile-filter-skills-content-container'>
              {
                skillPath && (skillPath as any) && (skillPath as any).skillGroups &&
                (skillPath as any).skillGroups.map((item: any) => (
                  <><SkillPathGroupComponent checkAll={showAll} skillPathGroup={item} isMobileClient={isMobileClient} resetCheckboxes={resetMobileFilterCheckboxes} skillFilterUpdate={HandleSkillFilterUpdate} /></>
                ))
              }
            </div>
            <div className='dis-flex dis-flex-jst-center gap-1 m-t-2'>
              <button className='btn-outlined-primary bdr-radius-0 fnt-wght-600' onClick={closeMobileFilterClick}>View Skills</button>
            </div>
          </section>
        </div>
        <MobileSkillView source='skills' isManager={false} currentUpn={undefined}
        employeeProgressions={employeeProgressions} employeeProgressionLevels={employeeProgressionLevels} filterArray={filterArray} 
        filteredSkillGroups={filteredSkillGroups} skillPath={skillPath} typeFilter=''
        bookmarkRemoved={HandleBookmarkRemoved} 
        bookmarkAdded={HandleBookmarkAdded} 
        progressionLevelAdded={HandleProgressionLevelAdded} 
        progressionLevelUpdated={HandleProgressionLevelUpdated} 
        progressionLevelRemoved={HandleProgressionLevelRemoved} />
      </>
    );
  } else {
    return (
      <>
        <div className={skillsContainerClasses.join(' ')} style={{borderColor : (skillPath as any).highlightColor}}>
          <div className='skills-desktop-max-width'>
          {(parentSkillPath as any)!==null && (<h2 className='fnt-wght-bold m-b-1 h1-size'>{(parentSkillPath as any).skillPathName}</h2>)}
          {!parentSkillPath && (<h2 className='fnt-wght-bold m-b-1 h1-size'>{(skillPath as any).skillPathName}</h2>)}
          </div>
          <div className='skills-desktop-max-width top'>
            <section>
            {
              parentSkillPath && (parentSkillPath as any).subSkillPaths && (parentSkillPath as any).subSkillPaths.length>0 && 
              (<><label htmlFor='subSkillSel'>Skill focus areas for your Discipline</label><br/><select id='subSkillSel' onChange={HandleSubSkillPathSelection} value={id}>
                <option value="">Select one</option>
                {(parentSkillPath as any).subSkillPaths.sort((a:ISkillPath, b:ISkillPath) => {if (a.skillPathName>b.skillPathName) return 1; return -1;}).map((subPath:ISkillPath) => (
                  <option value={subPath.skillPathId}>{subPath.skillPathName}</option>
                  ))}
                </select></>)
            }
            {
              skillPath && (skillPath as any) && (skillPath as any).skillPathDescription && (skillPath as any).skillPathDescription && (
                returnDraftJSContentAsHTML((skillPath as any).skillPathDescription)
              )
            }
            {
              skillPath && (skillPath as any).subSkillPaths && (skillPath as any).subSkillPaths.length>0 && 
              (<>Skill focus areas for your Discipline<br/><select onChange={HandleSubSkillPathSelection}>
                <option value="">Select one</option>
                {(skillPath as any).subSkillPaths.sort((a:ISkillPath, b:ISkillPath) => {if (a.skillPathName>b.skillPathName) return 1; return -1;}).map((subPath:ISkillPath) => (<option value={subPath.skillPathId}>{subPath.skillPathName}</option>))}
                </select></>)
            }
            </section>
            <section>
            {
              skillPath && (skillPath as any) && (skillPath as any).skillGroups && (skillPath as any).skillGroups.length>0 && 
              (<p className='m-t-0'>Select the skills you want to learn more about and view the skills matrix.</p>)}
              <div className='skill-group-container'>
                {
                  skillPath && (skillPath as any) && (skillPath as any).skillGroups &&
                  (skillPath as any).skillGroups.map((item: any, index:number) => (
                    <div>
                      <SkillPathGroupComponent key={item.skillGroupId + index} checkAll={showAll} skillPathGroup={item} isMobileClient={isMobileClient} resetCheckboxes={resetMobileFilterCheckboxes}  skillFilterUpdate={HandleSkillFilterUpdate} />
                    </div>
                  ))
                }
              </div>
            </section>
          </div>
        </div>
        <div className='core-desktop-max-width bottom p-t-1-75 p-b-1-5 sticky-top bg-white'>
          <div>&nbsp;</div>
          {
            skillPath && (skillPath as any) && (skillPath as any).skillGroups && JSON.stringify(filterArray)!=='{}' &&
            (skillPath as any).skillLevels.map((skillLevel: any, index: number) => (
              <div className='aln-center'>
                <LevelIcon
                  iconName={getLevelIcon(index)}
                  iconClassNames={['level-icons', 'm-b--75']}
                  levelText={skillLevel.skillLevelName}
                  levelTextClassNames={['fnt-wght-900', 'fnt-sz-med-lrg', 'm-b--50']}
                  detailText={skillLevel.skillLevelSubtitle}
                  detailTextClassNames={['fnt-wght-900', 'fnt-sz-sml-med']}
                  //@ts-ignore
                  iconColor={skillPath.highlightColor}
                />
              </div>
            ))
          }
        </div>
        {
          filteredSkillGroups && (skillPath as any) && (skillPath as any).skillLevels &&
          //@ts-ignore
          filteredSkillGroups.map((sklGrp: any, index: number) => (
            <>
              {
                //@ts-ignore
                sklGrp && sklGrp.skills && sklGrp.skills.length && sklGrp.skills.map((skill: ISkill) => (
                  <div key={skill.SkillId}><SkillDivider
                    dividerClassNames={['bg-secondary', 'p-t--50', 'p-b--50', "skill-divider-container"]}
                    headingLevel={4}
                    skillLevels={(skillPath as any).skillLevels as ISkillLevel[]}
                    headingClassNames={['clr-white', 'fnt-wght-500', 'm-0']}
                    dividerText={getDividerText((skillPath as any).skillPathName, sklGrp.skillGroupName, skill.skillName)}
                    tooltipContent={skill.skillDescription}
                    //@ts-ignore
                    backgroundColor={skillPath.highlightColor}
                  />
                  <DesktopSkillGrid source='skills'
                  progression={employeeProgressions.find((ep:any) => ep.skillId===skill.SkillId)}
                  skillLevels={(skillPath as any).skillLevels as ISkillLevel[]}
                  skill={skill} 
                  isManager={false} 
                  currentUpn={undefined}
                  employeeProgressionLevels={employeeProgressionLevels}
                  progressionLevelAdded={HandleProgressionLevelAdded}
                  progressionLevelRemoved={HandleProgressionLevelRemoved}
                  progressionLevelUpdated={HandleProgressionLevelUpdated}
                  bookmarkRemoved={HandleBookmarkRemoved}
                  bookmarkAdded={HandleBookmarkAdded}
                  //@ts-ignore
                  borderColor={skillPath.highlightColor}
                  />
                  </div>
                ))
              }
            </>
          ))
        }
      </>
    );
  }


};

export default SkillPathPage;